import {useEffect, useState} from "react";

function TabContent({tab}) {
  let [fade, setFade] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setFade("end1");
    }, 50);
    return () => {
      setFade("");
    };
  }, [tab]);
  return <div className={"start1 " + fade}>{[<div>내용0</div>, <div>내용1</div>, <div>내용2</div>][tab]}</div>;
}
export default TabContent;
